// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardDiv{
    /* background-color: bisque; */
    height: 500px;
    width: 80%;
    margin: auto;
    margin-top: 5%;
}
.dashHrLine{
    color: #4F80FF;
    height: 2px;
    background-color: #4F80FF;
    width: 100%;
    margin-top: 2%;
    margin-bottom: 5%;
}
.formTitle {
    text-align: center;
    /* color: #174f5d;
    color: #35b276;
    color: #151e3d;
    color: #174f5d; */
    color: #17213A;
    font-weight: 600;
    margin-top: 2%;
    font-family: 'Open Sans', sans-serif;
  
  }
  
  .formSubText {
    color: #17213A;
    text-align: center;
    width: 78%;
    margin: auto;
    margin-bottom: 4%;
  }
  .dashHeader{
    position: relative;
  }
  .createDoc {
    width: 15%;
    right:  0%;
    top: -15%;
    position: absolute;
    border-radius: 26px;
    /* background-color: #35b276; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    color: white;
    border: none;
    height: 42px; 
}
.uploadDoc {
    width: 18%;
    right:  16%;
    top: -15%;
    position: absolute;
    border-radius: 26px;
    /* background-color: #35b276; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    color: white;
    border: none;
    height: 42px; 
}
.createDoc:hover {
    width: 15%;
    right:  0%;
    top: -15%;
    position: absolute;
    border-radius: 26px;
    color: white;
    border: none;
    height: 42px; 
}
.resume1Div{
    /* background-color: bisque; */
    /* width: 33.33%; */
    align-items: left;
    text-align: left;

}
.resumeImg{
    width: 196px;
    margin: auto;
    height: 273px;
    margin-bottom: 12%;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}
.resumeTitle{
    margin-top: 0;
}
.resumeDesc{
    margin-top: 0;
    font-size: 14px;
    font-style: italic;
    color: #17213A;
    margin-bottom: 15%;
}
.editResumeOptions{
    padding-left: 10%;
    /* padding-top: 3%; */
}

@media screen and (max-width: 1024px) {
  .editResumeOptions {
      padding-left: 20%;
  }
  .editResumeBtns {
    width: 100% !important;
  }
}
.editResumeBtns{
    /* background-color: white !important; */
    border: none;
    margin-bottom: 4%;
    color: #ffffff;
    /* color: #174f5d; */
    /* color: rgb(20, 95, 156);
    color: white;
    color: #174f5d; */
    /* box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px; */
    width: 83%;
    text-align: left;
    padding: 2%;
    padding-left: 4%;
    /* background-color: #5ec57e !important; */
    /* background-color: white !important; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
}
.editResumeBtns:hover{
    background-color: white !important;
    background-color: #5ec57e !important;
    border: none;
    margin-bottom: 4%;
    color: #5ec57e;
    color: #174f5d;
    color: rgb(20, 95, 156);
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    width: 83%;
    text-align: left;
    padding: 2%;
    padding-left: 4%;
    margin-bottom: 6%;
    color: #5ec57e;
    color: white;
    /* color: #174f5d; */
}
.addResumePlusBtn{
    width: 27% !important;
    background-color: #5ec57e !important;
    color: white;
    /* margin: auto; */
}
.addResumePlusBtn:hover{
    width: 27% !important;
    background-color: #5ec57e !important;
    color: rgb(255, 255, 255);
}
.addNewResumeDiv{
    /* background-color: #151e3d; */
    width: 50%;
    height: 273px;
    width: 196px;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
align-items: left;
text-align: center;
padding-top: 18%;
border: 2px dotted #0c99cf;
}
.tokensBtn{
    background-color: transparent;
    border: none;
    position: absolute;
    right: 17%;
    top: 3.5%;
    z-index: 45;
    font-size: 16px;
}
.applyButton {
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    color: white; /* White text */
    border: none; /* No border */
    padding: 10px 20px; /* Padding */
    text-align: center; /* Centered text */
    text-decoration: none; /* No underline */
    display: inline-block; /* Inline-block display */
    font-size: 16px; /* Font size */
    margin: 4px 2px; /* Margin */
    cursor: pointer; /* Pointer cursor on hover */
    border-radius: 20px; /* Rounded corners */
}
.viewButton {
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    color: white; /* White text */
    border: none; /* No border */
    padding: 10px 20px; /* Padding */
    text-align: center; /* Centered text */
    text-decoration: none; /* No underline */
    display: inline-block; /* Inline-block display */
    font-size: 16px; /* Font size */
    margin: 4px 2px; /* Margin */
    cursor: pointer; /* Pointer cursor on hover */
    border-radius: 20px; /* Rounded corners */
}
.modal {
    display: block; /* Show the modal */
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.4);
  }
  
  .modal-content {
    background-color: #fefefe;
    margin: 10% auto;
    padding: 20px;
    border-radius: 8px;
    width: 50%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
  
  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
  }
  
  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
  }
  
  .resume-selector-title {
    margin-bottom: 20px;
    font-size: 24px;
    text-align: center;
  }
  
  .resume-list {
    list-style-type: none;
    padding: 0;
  }
  
  .resume-list-item {
    margin: 10px 0;
  }
  
  .resume-button {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    background-color: #45a049;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .resume-button.selected {
    background-color: #245326;
  }

@media screen and (max-width: 890px) {
  .resume1Div {
      width: 100%; /* Set width to 100% for mobile and tablet */
  }
}

@media screen and (max-width: 480px) {
  .dashboardDiv{
    margin-top: 12%;
  }
}

@media screen and (max-width: 1024px) {
  .uploadDoc {
    width: 34%;
    right: 28%;
    top: -11%;
    position: absolute;
    border-radius: 26px;
    /* background-color: #35b276; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    color: white;
    border: none;
    height: 34px; 
    font-size: 10px;
  }

  .createDoc {
    width: 30%;
    right:  -4%;
    top: -15%;
    position: absolute;
    border-radius: 26px;
    /* background-color: #35b276; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    color: white;
    border: none;
    height: 34px; 
    font-size: 10px;
  }

  .createDoc:hover {
    width: 30%;
    right:  -2%;
    top: -15%;
    position: absolute;
    border-radius: 26px;
    color: white;
    border: none;
    height: 34px; 
    font-size: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styleSheet/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,aAAa;IACb,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;AACA;IACI,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB;;;qBAGiB;IACjB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,oCAAoC;;EAEtC;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,kEAAkE;IAClE,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;AACA;IACI,UAAU;IACV,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,kEAAkE;IAClE,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;AACA;IACI,UAAU;IACV,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;AACA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;;AAEpB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,8IAA8I;IAC9I,yFAAyF;AAC7F;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;EACE;MACI,iBAAiB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;IACI,wCAAwC;IACxC,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB;;qBAEiB;IACjB,+FAA+F;IAC/F,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,0CAA0C;IAC1C,wCAAwC;IACxC,kEAAkE;AACtE;AACA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,uBAAuB;IACvB,yFAAyF;IACzF,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,yBAAyB;AAC7B;AACA;IACI,+BAA+B;IAC/B,UAAU;IACV,aAAa;IACb,YAAY;IACZ,yFAAyF;IACzF,yFAAyF;IACzF,qFAAqF;AACzF,iBAAiB;AACjB,kBAAkB;AAClB,gBAAgB;AAChB,0BAA0B;AAC1B;AACA;IACI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,eAAe;AACnB;AACA;IACI,kEAAkE;IAClE,YAAY,EAAE,eAAe;IAC7B,YAAY,EAAE,cAAc;IAC5B,kBAAkB,EAAE,YAAY;IAChC,kBAAkB,EAAE,kBAAkB;IACtC,qBAAqB,EAAE,iBAAiB;IACxC,qBAAqB,EAAE,yBAAyB;IAChD,eAAe,EAAE,cAAc;IAC/B,eAAe,EAAE,WAAW;IAC5B,eAAe,EAAE,4BAA4B;IAC7C,mBAAmB,EAAE,oBAAoB;AAC7C;AACA;IACI,kEAAkE;IAClE,YAAY,EAAE,eAAe;IAC7B,YAAY,EAAE,cAAc;IAC5B,kBAAkB,EAAE,YAAY;IAChC,kBAAkB,EAAE,kBAAkB;IACtC,qBAAqB,EAAE,iBAAiB;IACxC,qBAAqB,EAAE,yBAAyB;IAChD,eAAe,EAAE,cAAc;IAC/B,eAAe,EAAE,WAAW;IAC5B,eAAe,EAAE,4BAA4B;IAC7C,mBAAmB,EAAE,oBAAoB;AAC7C;AACA;IACI,cAAc,EAAE,mBAAmB;IACnC,eAAe;IACf,UAAU;IACV,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;EACE;MACI,WAAW,EAAE,4CAA4C;EAC7D;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,kEAAkE;IAClE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,kEAAkE;IAClE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".dashboardDiv{\n    /* background-color: bisque; */\n    height: 500px;\n    width: 80%;\n    margin: auto;\n    margin-top: 5%;\n}\n.dashHrLine{\n    color: #4F80FF;\n    height: 2px;\n    background-color: #4F80FF;\n    width: 100%;\n    margin-top: 2%;\n    margin-bottom: 5%;\n}\n.formTitle {\n    text-align: center;\n    /* color: #174f5d;\n    color: #35b276;\n    color: #151e3d;\n    color: #174f5d; */\n    color: #17213A;\n    font-weight: 600;\n    margin-top: 2%;\n    font-family: 'Open Sans', sans-serif;\n  \n  }\n  \n  .formSubText {\n    color: #17213A;\n    text-align: center;\n    width: 78%;\n    margin: auto;\n    margin-bottom: 4%;\n  }\n  .dashHeader{\n    position: relative;\n  }\n  .createDoc {\n    width: 15%;\n    right:  0%;\n    top: -15%;\n    position: absolute;\n    border-radius: 26px;\n    /* background-color: #35b276; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    color: white;\n    border: none;\n    height: 42px; \n}\n.uploadDoc {\n    width: 18%;\n    right:  16%;\n    top: -15%;\n    position: absolute;\n    border-radius: 26px;\n    /* background-color: #35b276; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    color: white;\n    border: none;\n    height: 42px; \n}\n.createDoc:hover {\n    width: 15%;\n    right:  0%;\n    top: -15%;\n    position: absolute;\n    border-radius: 26px;\n    color: white;\n    border: none;\n    height: 42px; \n}\n.resume1Div{\n    /* background-color: bisque; */\n    /* width: 33.33%; */\n    align-items: left;\n    text-align: left;\n\n}\n.resumeImg{\n    width: 196px;\n    margin: auto;\n    height: 273px;\n    margin-bottom: 12%;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;\n    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n}\n.resumeTitle{\n    margin-top: 0;\n}\n.resumeDesc{\n    margin-top: 0;\n    font-size: 14px;\n    font-style: italic;\n    color: #17213A;\n    margin-bottom: 15%;\n}\n.editResumeOptions{\n    padding-left: 10%;\n    /* padding-top: 3%; */\n}\n\n@media screen and (max-width: 1024px) {\n  .editResumeOptions {\n      padding-left: 20%;\n  }\n  .editResumeBtns {\n    width: 100% !important;\n  }\n}\n.editResumeBtns{\n    /* background-color: white !important; */\n    border: none;\n    margin-bottom: 4%;\n    color: #ffffff;\n    /* color: #174f5d; */\n    /* color: rgb(20, 95, 156);\n    color: white;\n    color: #174f5d; */\n    /* box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px; */\n    width: 83%;\n    text-align: left;\n    padding: 2%;\n    padding-left: 4%;\n    /* background-color: #5ec57e !important; */\n    /* background-color: white !important; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n}\n.editResumeBtns:hover{\n    background-color: white !important;\n    background-color: #5ec57e !important;\n    border: none;\n    margin-bottom: 4%;\n    color: #5ec57e;\n    color: #174f5d;\n    color: rgb(20, 95, 156);\n    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n    width: 83%;\n    text-align: left;\n    padding: 2%;\n    padding-left: 4%;\n    margin-bottom: 6%;\n    color: #5ec57e;\n    color: white;\n    /* color: #174f5d; */\n}\n.addResumePlusBtn{\n    width: 27% !important;\n    background-color: #5ec57e !important;\n    color: white;\n    /* margin: auto; */\n}\n.addResumePlusBtn:hover{\n    width: 27% !important;\n    background-color: #5ec57e !important;\n    color: rgb(255, 255, 255);\n}\n.addNewResumeDiv{\n    /* background-color: #151e3d; */\n    width: 50%;\n    height: 273px;\n    width: 196px;\n    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\nalign-items: left;\ntext-align: center;\npadding-top: 18%;\nborder: 2px dotted #0c99cf;\n}\n.tokensBtn{\n    background-color: transparent;\n    border: none;\n    position: absolute;\n    right: 17%;\n    top: 3.5%;\n    z-index: 45;\n    font-size: 16px;\n}\n.applyButton {\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    color: white; /* White text */\n    border: none; /* No border */\n    padding: 10px 20px; /* Padding */\n    text-align: center; /* Centered text */\n    text-decoration: none; /* No underline */\n    display: inline-block; /* Inline-block display */\n    font-size: 16px; /* Font size */\n    margin: 4px 2px; /* Margin */\n    cursor: pointer; /* Pointer cursor on hover */\n    border-radius: 20px; /* Rounded corners */\n}\n.viewButton {\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    color: white; /* White text */\n    border: none; /* No border */\n    padding: 10px 20px; /* Padding */\n    text-align: center; /* Centered text */\n    text-decoration: none; /* No underline */\n    display: inline-block; /* Inline-block display */\n    font-size: 16px; /* Font size */\n    margin: 4px 2px; /* Margin */\n    cursor: pointer; /* Pointer cursor on hover */\n    border-radius: 20px; /* Rounded corners */\n}\n.modal {\n    display: block; /* Show the modal */\n    position: fixed;\n    z-index: 1;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: rgba(0,0,0,0.4);\n  }\n  \n  .modal-content {\n    background-color: #fefefe;\n    margin: 10% auto;\n    padding: 20px;\n    border-radius: 8px;\n    width: 50%;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  }\n  \n  .close {\n    color: #aaa;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n    cursor: pointer;\n  }\n  \n  .close:hover,\n  .close:focus {\n    color: black;\n    text-decoration: none;\n  }\n  \n  .resume-selector-title {\n    margin-bottom: 20px;\n    font-size: 24px;\n    text-align: center;\n  }\n  \n  .resume-list {\n    list-style-type: none;\n    padding: 0;\n  }\n  \n  .resume-list-item {\n    margin: 10px 0;\n  }\n  \n  .resume-button {\n    width: 100%;\n    padding: 10px;\n    font-size: 16px;\n    background-color: #45a049;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .resume-button.selected {\n    background-color: #245326;\n  }\n\n@media screen and (max-width: 890px) {\n  .resume1Div {\n      width: 100%; /* Set width to 100% for mobile and tablet */\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .dashboardDiv{\n    margin-top: 12%;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .uploadDoc {\n    width: 34%;\n    right: 28%;\n    top: -11%;\n    position: absolute;\n    border-radius: 26px;\n    /* background-color: #35b276; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    color: white;\n    border: none;\n    height: 34px; \n    font-size: 10px;\n  }\n\n  .createDoc {\n    width: 30%;\n    right:  -4%;\n    top: -15%;\n    position: absolute;\n    border-radius: 26px;\n    /* background-color: #35b276; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    color: white;\n    border: none;\n    height: 34px; \n    font-size: 10px;\n  }\n\n  .createDoc:hover {\n    width: 30%;\n    right:  -2%;\n    top: -15%;\n    position: absolute;\n    border-radius: 26px;\n    color: white;\n    border: none;\n    height: 34px; \n    font-size: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
